import { render } from "./EditLead.vue?vue&type=template&id=5a9f4264&scoped=true"
import script from "./EditLead.vue?vue&type=script&lang=js"
export * from "./EditLead.vue?vue&type=script&lang=js"

import "./EditLead.vue?vue&type=style&index=0&id=5a9f4264&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a9f4264"

export default script